import { render, staticRenderFns } from "./home-mobile.vue?vue&type=template&id=24c8f90e"
import script from "./home-mobile.vue?vue&type=script&lang=js"
export * from "./home-mobile.vue?vue&type=script&lang=js"
import style0 from "./home-mobile.vue?vue&type=style&index=0&id=24c8f90e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports